import http from '@util/http';
import { finance } from '@api/req';

/**
 * 平台划款
 */
export async function queryPlatformTransferList(params) {
  return http.get(finance.GET_PLATFORM_TRANSFER_LIST, params);
}

export async function queryPlatformTransferMyList(params) {
  return http.get(finance.GET_PLATFORM_TRANSFER_MY, params);
}

export async function queryMyPlatformTransferCheckList(params) {
  return http.get(finance.GET_PLATFORM_TRANSFER_CHECK, params);
}

export async function queryPlatformTransferOrgStatic(params) {
  return http.get(finance.GET_PLATFORM_TRANSFER_STATIC_ORG, params);
}

export async function queryPlatformTransferOrgRecord(params) {
  return http.get(finance.GET_PLATFORM_TRANSFER_RECORD_ORG, params);
}

export async function queryPlatformTransferInfo(params) {
  return http.get(finance.GET_PLATFORM_TRANSFER_INFO, params);
}

export async function querySavePlatformTransfer(params) {
  return http.post(finance.PLATFORM_TRANSFER_SAVE, params);
}

export async function queryDeletePlatformTransfer(params) {
  return http.get(finance.PLATFORM_TRANSFER_DELETE, params);
}

export async function queryNextPlatformTransfer(params) {
  return http.get(finance.PLATFORM_TRANSFER_NEXT, params);
}

export async function queryReturnPlatformTransfer(params) {
  return http.post(finance.PLATFORM_TRANSFER_RETURN, params);
}

export async function queryCallbackPlatformTransfer(params) {
  return http.get(finance.PLATFORM_TRANSFER_CALLBACK, params);
}

export async function queryPlatformTransferWorkflow(params) {
  return http.get(finance.PLATFORM_TRANSFER_WORKFLOW, params);
}



// WEBPACK FOOTER //
// ./src/api/finance/platformTransfer.js